export const stringAvatar = (name: string) => {
  const fullName = name.split(' ');
  return {
    children: `${fullName.map((item) => item[0]).join('')}`,
  };
};
